<template lang="pug">
div
  section.u-mt-md
    AppTitle.u-mb-xm(:title="$t('mantra')")
    .grid.is-widescreen-8.is-desktop-10
      .column
        .artwork-search(ref="search")
          input.input(type="search" :placeholder="$t('searchPlaceholder')")

  //- section.u-mt-xs
  //-   AppLink(v-for="item,key in $t('cats')" :key="key" :to="`/tools/atlas/${key}`" :title="item" class="button-link is-small") {{item}}

  .u-mb-md

</template>

<style lang="stylus">
.atlas
  &-category
    padding: unitRes(40, 80) unitRes(20, 40)
    display: flex
    align-items: center
    justify-content: center
    flex-direction: column
    text-align: center

    h4
      margin: 0 0

    .icon
      font-size: 40px
</style>

<script>
export default {
  head() {
    const $t = this.$t.bind(this);
    return {
      title: $t('pageTitle'),
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          property: 'og:title',
          content: $t('pageTitle')
        },
        {
          hid: 'description',
          name: 'description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: $t('pageDesc')
        }
      ]
    };
  }
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"Atlas",
    "pageDesc":"Atlas is Baianat encyclopedia for strategists, designers, techies and developers where they can find all the information needed to make the",
    "mantra":"Search |anything.",
    "searchPlaceholder":"Search here..."
  },
  "ar": {
    "pageTitle":"أطلس",
    "pageDesc":"أطلس هو موسوعة بيانات فى التصميم و البرمجة و البزنس والتكنولوجيا تٌمكن المتخصصين من البحث عن أى معلومة يحتاجونها.",
    "mantra":"ابحث عن |أي شيء.",
    "searchPlaceholder":"ابحث هنا..."

  }
}
</i18n>
